// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + "vendor-xlsx" + "." + "0a8a7e94fc3af0d03529" + ".js";
};